export const hexColors = {
     'Emergency - Toothpain/Broken tooth' : 'ED7D31',
     'Teeth Whitening' : 'A5A5A5',
     'Dental checkup' : 'FFC000',
     'Teeth cleaning' : '5B9BD5',
     'Online Dentist' : '70AD47',
     'Blocked' : '000000',
};
